interface ActionBarProps {
  children: React.ReactNode;
}

export default function ActionBar({ children }: ActionBarProps) {
  return (
    <div className="fixed top-14 md:top-16 left-0 right-0 md:left-auto z-20 bg-dark-bg/95 backdrop-blur-sm border-b border-dark-border px-3 md:px-6 py-3">
      {children}
    </div>
  );
}
